import { render, staticRenderFns } from "./FinancesClients.vue?vue&type=template&id=2e19b1f6&scoped=true"
import script from "./FinancesClients.vue?vue&type=script&lang=js"
export * from "./FinancesClients.vue?vue&type=script&lang=js"
import style0 from "./FinancesClients.vue?vue&type=style&index=0&id=2e19b1f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e19b1f6",
  null
  
)

export default component.exports